<script setup lang="ts">
  import { useInitPage } from '@/composables/useInitPage'

  const pageStory = await useInitPage('check-in')

  definePageMeta({
    pageType: 'cki',
    layout: 'index-page'
  })

  useMetaTags(pageStory)
</script>

<template>
  <StoryblokComponent
    v-if="pageStory?.content"
    :blok="pageStory?.content"
  />
</template>
